import React from 'react'

const Landing = () => {
    return (
        <div>
            this is Landing Page
        </div>
    )
}

export default Landing
